import clsx from 'clsx';
import sanitizeHtml from 'sanitize-html';
import type { GetMessagesResponse } from '@shared/api/rest';
import PrintIcon from '@assets/icons/print.svg';
import CloseIcon from '@assets/icons/close.svg';
import { SearchHighlight } from '@shared/widgets';

interface IViewMessageProps {
  className?: string;
  isShown: boolean;
  message: GetMessagesResponse;
  searchQuery?: string;
  hideLetter?: (e: React.MouseEvent<SVGSVGElement>) => void;
  handlePrint?: () => void;
  scrollable?: boolean;
}

export const ViewMessage = (props: IViewMessageProps) => {
  return (
    <div
      id={props.message.Id}
      className={clsx(
        'message-item__full absolute top-[-42px] left-[-10px] z-[50] scale-0 rounded-sm border-t border-t-[#ececec] bg-[#fff] opacity-0 shadow-[12px_12px_24px_#00000033]',
        props.isShown &&
          '!right-[-12px] !scale-100 !opacity-100 max-md:!fixed max-md:!top-[10px] max-md:!right-[10px] max-md:!bottom-[10px] max-md:!left-[10px]',
        props.className,
      )}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div className='flex h-[64px] items-center justify-between rounded-t-sm bg-[#efefef] pr-6 pl-8 font-medium uppercase'>
        <div className='mr-7.5 overflow-hidden text-ellipsis whitespace-nowrap'>
          <SearchHighlight searchText={props.searchQuery}>{sanitizeHtml(props.message.Subject)}</SearchHighlight>
        </div>
        <div className='flex items-center justify-between select-none'>
          {props.handlePrint && (
            <div className='flex cursor-pointer items-center justify-start' onClick={props.handlePrint}>
              <PrintIcon className='text-[#343434]' />
              <div className='ml-2 text-sm capitalize'>Print</div>
            </div>
          )}
          {props.hideLetter && <CloseIcon className='ml-9 cursor-pointer text-[#343434]' onClick={props.hideLetter} />}
        </div>
      </div>
      <div style={{ height: 'calc(100% - 64px)' }}>
        <div className={clsx('h-full px-7.5 py-6 text-xs font-medium whitespace-pre-wrap uppercase', props.scrollable && 'overflow-auto')}>
          <SearchHighlight searchText={props.searchQuery}>{sanitizeHtml(props.message.Body)}</SearchHighlight>
        </div>
      </div>
    </div>
  );
};
